
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Phase II: Verbreitung`}</h3>
    <p>{`Nach zwei bis vier Tagen `}<strong parentName="p">{`werden Sie selbst ansteckend`}</strong>{`, ohne dass Sie dies
bemerken. Eine Person bleibt durchschnittlich 5,5 Tage und bis zu zwei Wochen in
diesem Stadium.`}</p>
    <p><strong parentName="p">{`Passen Sie auf!`}</strong>{` `}<em parentName="p">{`Zu langsames Scrollen führt zu Ansteckungen.`}</em></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;